module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-content",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('button-tab', {
    model: {
      value: (_vm.option),
      callback: function($$v) {
        _vm.option = $$v
      },
      expression: "option"
    }
  }, [_c('button-tab-item', {
    attrs: {
      "selectd": _vm.option === 0
    }
  }, [_vm._v("今天")]), _vm._v(" "), _c('button-tab-item', {
    attrs: {
      "selectd": _vm.option === 1
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('button-tab-item', {
    attrs: {
      "selectd": _vm.option === 2
    }
  }, [_vm._v("本月")])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "基本概况"
    }
  }), _vm._v(" "), _c('cell-form-preview', {
    attrs: {
      "list": _vm.data.all
    }
  })], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "商品统计"
    }
  }), _vm._v(" "), _c('cell-form-preview', {
    attrs: {
      "list": _vm.data.goods
    }
  })], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "当前未发货"
    }
  }), _vm._v(" "), _c('cell-form-preview', {
    attrs: {
      "list": _vm.data.not_send
    }
  })], 1)], 1), _vm._v(" "), _c('tabbar', [_c('tabbar-item', {
    attrs: {
      "selected": "",
      "link": "/uc/adminstatic"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("概况")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/uc/adminmemberinfo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("会员")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/uc/adminorderlist"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("订单")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d04797"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/AdminStatic.vue
// module id = 641
// module chunks = 0